import { Component, inject } from '@angular/core';
import { ToastService } from './toast.service';

@Component({
  selector: 'app-toast-host',
  template: `
    <div class="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex flex-col items-center gap-2 px-4" aria-live="polite">
      @for (t of toasts.toasts(); track t.id) {
        <div
          class="pointer-events-auto flex max-w-md items-start gap-3 rounded-xl px-4 py-3 text-sm text-white shadow-lg"
          [class.bg-emerald-700]="t.kind === 'success'"
          [class.bg-red-700]="t.kind === 'error'"
          [attr.role]="t.kind === 'error' ? 'alert' : 'status'"
        >
          <span class="flex-1">{{ t.text }}</span>
          <button type="button" class="font-bold" aria-label="ปิด" (click)="toasts.dismiss(t.id)">×</button>
        </div>
      }
    </div>
  `,
})
export class ToastHost {
  protected readonly toasts = inject(ToastService);
}
